import { defineStore } from 'pinia';
import { reactive } from 'vue';
import { api } from '@/server';
import dayjs from 'dayjs';
export const useProjectFormStore = defineStore('projectFormStore', () => {
  const state = reactive({
    id: '',
    name: '',
    code: '',
    budgetItem: '',
    depDuty: '',
    depDutyName: '',
    jobActivity: '',
    jobActivityName: '',
    isMajor: false,
    nature: '',
    natureName: '',
    projType: '',
    projTypeName: '',
    mainstay: '',
    mainstayName: '',
    timeLimit: 0,
    startDate: '',
    endDate: '',
    disburseType: '',
    disburseTypeName: '',
    destUnit: '',
    destUnitName: '',
    fund: '',
    detail: '',
    compTpl: '',
    compTplName: '',
    total: '',
    investment: '',
    level: '',
    levelName: '',
    sysProjType: '',
    sysProjTypeName: '',
    paymentType: '',
    distribution: '',
    fundMgr: '',
    fundMgrName: '',
    isPending: false,
    hotClass: '',
    hotClassName: '',
    isNewly: false,
    isCapital: false,
    isResearch: false,
    isReview: false,
    isInform: false,
    is3PMode: false,
    isSpecial: false,
    isInterest: false,
    bondCode: '',
    contactPer: '',
    contactTel: '',
    mobile: '',
    desc: '',
    remark: ''
  });
  const {
    runAsync: getProjectDetail,
    loading
  } = fetchApi(api.kpi.project.getDetail);
  const {
    runAsync: saveProject,
    loading: saveLoading
  } = fetchApi(api.kpi.project.save, {
    showError: false
  });
  const resetForm = () => {
    Object.assign(state, {
      id: '',
      name: '',
      code: '',
      budgetItem: '',
      depDuty: '',
      depDutyName: '',
      jobActivity: '',
      jobActivityName: '',
      isMajor: false,
      nature: '',
      natureName: '',
      projType: '',
      projTypeName: '',
      mainstay: '',
      mainstayName: '',
      timeLimit: 0,
      startDate: '',
      endDate: '',
      disburseType: '',
      disburseTypeName: '',
      destUnit: '',
      destUnitName: '',
      fund: '',
      detail: '',
      compTpl: '',
      compTplName: '',
      total: '',
      investment: '',
      level: '',
      levelName: '',
      sysProjType: '',
      sysProjTypeName: '',
      paymentType: '',
      distribution: '',
      fundMgr: '',
      fundMgrName: '',
      isPending: false,
      hotClass: '',
      hotClassName: '',
      isNewly: false,
      isCapital: false,
      isResearch: false,
      isReview: false,
      isInform: false,
      is3PMode: false,
      isSpecial: false,
      isInterest: false,
      bondCode: '',
      contactPer: '',
      contactTel: '',
      mobile: '',
      desc: '',
      remark: ''
    });
  };
  const createForm = async id => {
    if (id === state.id) {
      return;
    }
    if (id === '') {
      resetForm();
      return;
    }
    state.id = id;
    const {
      error,
      ...res
    } = await getProjectDetail({
      id
    });
    if (error) return;
    const {
      name = '',
      code = '',
      budgetItem = '',
      depDuty: resDepDuty = {},
      jobActivity: resJobActivity = {},
      isMajor = false,
      nature: resNature = {},
      projType: resProjType = {},
      mainstay: resMainstay = {},
      timeLimit = '',
      startDate = '',
      endDate = '',
      disburseType: resDisburseType = {},
      destUnit: resDestUnit = {},
      fund = '',
      detail = '',
      compTpl: resCompTpl = {},
      total = '',
      investment = '',
      level: resLevel = {},
      sysProjType: resSysProjType = {},
      paymentType = '',
      distribution = '',
      fundMgr: resFundMgr = {},
      isPending = false,
      hotClass: resHotClass = {},
      isNewly = false,
      isCapital = false,
      isResearch = false,
      isReview = false,
      isInform = false,
      is3PMode = false,
      isSpecial = false,
      isInterest = false,
      bondCode = '',
      contactPer = '',
      contactTel = '',
      mobile = '',
      desc = '',
      remark = ''
    } = res || {};
    const tStartDate = dayjs(startDate);
    const tEndDate = dayjs(endDate);
    const formStartDate = tStartDate.isValid() ? tStartDate.format('YYYY-MM-DD') : '';
    const formEndDate = tEndDate.isValid() ? tEndDate.format('YYYY-MM-DD') : '';
    const {
      value: depDuty = '',
      label: depDutyName = ''
    } = resDepDuty || {};
    const {
      value: jobActivity = '',
      label: jobActivityName = ''
    } = resJobActivity || {};
    const {
      value: nature = '',
      label: natureName = ''
    } = resNature || {};
    const {
      value: projType = '',
      label: projTypeName = ''
    } = resProjType || {};
    const {
      value: mainstay = '',
      label: mainstayName = ''
    } = resMainstay || {};
    const {
      value: disburseType = '',
      label: disburseTypeName = ''
    } = resDisburseType || {};
    const {
      value: destUnit = '',
      label: destUnitName = ''
    } = resDestUnit || {};
    const {
      value: compTpl = '',
      label: compTplName = ''
    } = resCompTpl || {};
    const {
      value: level = '',
      label: levelName = ''
    } = resLevel || {};
    const {
      value: sysProjType = '',
      label: sysProjTypeName = ''
    } = resSysProjType || {};
    const {
      value: fundMgr = '',
      label: fundMgrName = ''
    } = resFundMgr || {};
    const {
      value: hotClass = '',
      label: hotClassName = ''
    } = resHotClass || {};
    Object.assign(state, {
      id,
      name,
      code,
      budgetItem,
      depDuty,
      depDutyName: `${depDuty}-${depDutyName}`,
      jobActivity,
      jobActivityName: `${jobActivity}-${jobActivityName}`,
      isMajor,
      nature,
      natureName: `${nature}-${natureName}`,
      projType,
      projTypeName: `${projType}-${projTypeName}`,
      mainstay,
      mainstayName: `${mainstay}-${mainstayName}`,
      timeLimit: parseInt(timeLimit, 10),
      startDate: formStartDate,
      endDate: formEndDate,
      disburseType,
      disburseTypeName: `${disburseType}-${disburseTypeName}`,
      destUnit,
      destUnitName: `${destUnit}-${destUnitName}`,
      fund,
      detail,
      compTpl,
      compTplName: `${compTpl}-${compTplName}`,
      total,
      investment,
      level,
      levelName: `${level}-${levelName}`,
      sysProjType,
      sysProjTypeName: `${sysProjType}-${sysProjTypeName}`,
      paymentType,
      distribution,
      fundMgr,
      fundMgrName: `${fundMgr}-${fundMgrName}`,
      isPending,
      hotClass,
      hotClassName: `${hotClass}-${hotClassName}`,
      isNewly,
      isCapital,
      isResearch,
      isReview,
      isInform,
      is3PMode,
      isSpecial,
      isInterest,
      bondCode,
      contactPer,
      contactTel,
      mobile,
      desc,
      remark
    });
  };
  const saveForm = async (reset = false) => {
    const {
      id,
      name,
      code,
      budgetItem,
      depDutyName: depDuty,
      jobActivityName: jobActivity,
      isMajor,
      natureName: nature,
      projTypeName: projType,
      mainstayName: mainstay,
      timeLimit,
      startDate,
      endDate,
      disburseTypeName: disburseType,
      destUnitName: destUnit,
      fund,
      detail,
      compTplName: compTpl,
      total,
      investment,
      levelName: level,
      sysProjTypeName: sysProjType,
      paymentType,
      distribution,
      fundMgrName: fundMgr,
      isPending,
      hotClassName: hotClass,
      isNewly,
      isCapital,
      isResearch,
      isReview,
      isInform,
      is3PMode,
      isSpecial,
      isInterest,
      bondCode,
      contactPer,
      contactTel,
      mobile,
      desc,
      remark
    } = state;
    const {
      error,
      id: resId
    } = await saveProject({
      id,
      name,
      code,
      budgetItem,
      depDuty,
      jobActivity,
      isMajor,
      nature,
      projType,
      mainstay,
      timeLimit,
      startDate,
      endDate,
      disburseType,
      destUnit,
      fund,
      detail,
      compTpl,
      total,
      investment,
      level,
      sysProjType,
      paymentType,
      distribution,
      fundMgr,
      isPending,
      hotClass,
      isNewly,
      isCapital,
      isResearch,
      isReview,
      isInform,
      is3PMode,
      isSpecial,
      isInterest,
      bondCode,
      contactPer,
      contactTel,
      mobile,
      desc,
      remark
    });
    if (error) return {
      error
    };
    if (reset) {
      resetForm();
    }
    return {
      id: resId
    };
  };
  return {
    formData: state,
    saveLoading,
    loading,
    resetForm,
    createForm,
    saveForm
  };
}, {
  persist: {
    enabled: true,
    key: 'ijx-user-project-form',
    storage: localStorage
  }
});